module.exports = __webpack_public_path__ + "img/icon-close.462b7313.svg";